import { LitElement, html, nothing } from 'lit';
import { property, queryAll } from 'lit/decorators.js';
import { styles } from '../view/styles';
import {
  ENTITIES_CLASS,
  ENTITIES_TYPES_ORDER,
  RESOURCES_CLASS,
  RESOURCES_TYPES_ORDER,
} from '../../../edr/incidentsGrid/types';
import { makeCounterText } from '../../../utils/formatter.utils';
import { EventsName } from '../types/types';
import { WEB_COMPONENT_GZ_ICON_LABEL } from '../../../webcomponents.constants';
import { GzIconLabelWebComponent } from '../../../ui/gzIconLabel';

export class OrganizationalImpactWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  sectionTitle = '';

  @property({ type: String, attribute: true, reflect: true })
  entitiesTitle = '';

  @property({ type: String, attribute: true, reflect: true })
  resourcesTitle = '';

  @property({
    type: Array,
    attribute: false,
    reflect: false,
  })
  entities: Array<any>;

  @property({
    type: Array,
    attribute: false,
    reflect: false,
  })
  resources: Array<any>;

  @queryAll(WEB_COMPONENT_GZ_ICON_LABEL)
  private iconLabels!: GzIconLabelWebComponent[];

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="content">
        <div class="panel-content">
          <gz-title class="title text-uppercase" fontweight="500" fontsize="16">${this.sectionTitle}</gz-title>

          <div class="entities-section d-flex flex-column mt-2">
            ${!this.entities || this.entities.length === 0
              ? nothing
              : html` <gz-title class="sub-title text-uppercase mb-1" fontsize="11" fontweight="500"
                    >${this.entitiesTitle}</gz-title
                  >
                  <div class="grid-layout">${this.renderEntities()}</div>`}
          </div>

          <div class="resources-section d-flex flex-column mt-2">
            ${!this.resources || this.resources.length === 0
              ? nothing
              : html` <gz-title class="sub-title text-uppercase mb-1" fontsize="11" fontweight="500"
                    >${this.resourcesTitle}</gz-title
                  >
                  <div class="grid-layout">${this.renderResources()}</div>`}
          </div>
        </div>
      </div>
    `;
  }

  renderEntities() {
    const map = {};
    for (const entitiesGroup of this.entities) {
      const { type, nodes } = entitiesGroup;
      map[type] = nodes;
    }

    return ENTITIES_TYPES_ORDER.map(type => {
      if (!map[type]) {
        return;
      }

      const textOnly = Translator.translateXdrEntityType(type);
      const tooltiptext = `${textOnly}: ${map[type].length}`;

      return html`<gz-tooltip id="${textOnly}" tooltiptext="${tooltiptext}"
        ><gz-icon-label
          @click="${e => this.handleEntityIconClicked(type, this.entities, e)}"
          label="${makeCounterText(map[type].length)}"
          icon="${ENTITIES_CLASS.get(type)}"
        ></gz-icon-label
      ></gz-tooltip>`;
    });
  }

  handleEntityIconClicked(type, entities, event) {
    this.removeActiveStateForIconsLabels();

    event.target.active = true;

    const clickEvent = new CustomEvent(EventsName.ENTITIES_CLICK, {
      detail: {
        type,
        entities,
      },
      bubbles: true,
      composed: true,
    });

    this.dispatchEvent(clickEvent);
  }

  removeActiveStateForIconsLabels() {
    this.iconLabels.forEach(iconLabel => {
      iconLabel.active = false;
    });
  }

  renderResources() {
    const map = {};
    for (const resourcesGroup of this.resources) {
      const { type, values } = resourcesGroup;
      map[type] = values;
    }

    return RESOURCES_TYPES_ORDER.map(type => {
      if (!map[type]) {
        return;
      }

      const textOnly = Translator.translateXdrResourceType(type);
      const tooltiptext = `${textOnly}: ${map[type].length}`;

      return html`<gz-tooltip id="${textOnly}" tooltiptext="${tooltiptext}"
        ><gz-icon-label
          @click="${e => {
            this.handleResourcesIconClicked(type, this.resources, e);
          }}"
          label="${makeCounterText(map[type].length)}"
          icon="${RESOURCES_CLASS.get(type)}"
        ></gz-icon-label
      ></gz-tooltip>`;
    });
  }

  handleResourcesIconClicked(type, resources, event) {
    this.removeActiveStateForIconsLabels();
    event.target.active = true;

    const clickEvent = new CustomEvent(EventsName.RESOURCES_CLICK, {
      detail: {
        type,
        resources,
      },
      bubbles: true,
      composed: true,
    });

    this.dispatchEvent(clickEvent);
  }
}
